import React from "react";
import { Check, Package, CheckCircle2, Truck, Home, Clock, XCircle } from "lucide-react";

const STEPS = [
  { key: "placed", label: "Order Placed", icon: Clock },
  { key: "confirmed", label: "Confirmed", icon: CheckCircle2 },
  { key: "packed", label: "Packed", icon: Package },
  { key: "shipped", label: "Shipped", icon: Truck },
  { key: "delivered", label: "Delivered", icon: Home },
];

export const OrderTimeline = ({ status }) => {
  if (status === "cancelled") {
    return (
      <div className="flex items-center gap-3 rounded-2xl bg-[#FEE2E2] border border-[#FCA5A5] p-4" data-testid="timeline-cancelled">
        <XCircle className="text-[#B91C1C]" size={22} />
        <p className="font-semibold text-[#B91C1C]">This order was cancelled.</p>
      </div>
    );
  }
  const current = Math.max(0, STEPS.findIndex((s) => s.key === status));
  return (
    <div className="flex justify-between" data-testid="order-timeline">
      {STEPS.map((s, i) => {
        const done = i <= current;
        const active = i === current;
        return (
          <div key={s.key} className="flex-1 flex flex-col items-center relative">
            {i > 0 && (
              <span className={`absolute top-5 right-1/2 w-full h-1 ${i <= current ? "bg-[#15803D]" : "bg-[#E7E0D6]"}`} style={{ zIndex: 0 }} />
            )}
            <div className={`relative z-10 h-10 w-10 rounded-full grid place-items-center border-2 ${done ? "bg-[#15803D] border-[#15803D] text-white" : "bg-white border-[#E7E0D6] text-[#B9A794]"} ${active ? "ring-4 ring-[#15803D]/20" : ""}`}>
              {done && !active ? <Check size={18} /> : <s.icon size={18} />}
            </div>
            <p className={`mt-2 text-[11px] sm:text-xs font-medium text-center ${done ? "text-[#1F130B]" : "text-[#9CA3AF]"}`}>{s.label}</p>
          </div>
        );
      })}
    </div>
  );
};
